/**
 * Component Registry for The Otis
 * 
 * Inherits from @vibesites-axia-residential-arc-living/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-axia-residential-arc-living/theme-preferred/registry';
import { PreferredEmployerProgram } from './components/PreferredEmployerProgram';
import { SightMapEmbed } from './components/SightMapEmbed';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  PreferredEmployerProgram,
  // Hardcoded Sightmap interactive map embed for the Interactive Map page.
  SightMapEmbed,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
